/** @format */

export function isAdmin() {
  return this.state.permissions.includes("admin");
}
